<template>
    <addresses-base :addresses="addresses">
        <template slot-scope="{ addressList }">
            <div class="">
                <transition-group name="list-complete" tag="div" class="flex flex-wrap items-center">
                    <address-item v-for="address in addressList" :key="address.id" :address="address"/>
                </transition-group>
            </div>
        </template>
    </addresses-base>
</template>

<script>
export default {
    props: {
        addresses: {
            type: Array,
            default: () => []
        }
    }
}
</script>
